import React, { useEffect, useRef, useState } from "react";
import helpersNumbers from "../../../helpers/numbers";
import httpService from "../../../services/httpServices/httpServices";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

export default function NotificationBell() {
  const [countNotificationBell, setCountNotificationBell] = useState(0);
  const intervalRef = useRef();
  useEffect(() => {
    const id = setInterval(() => {
      checkUserHaveNotificationBell();
    }, 7000);
    intervalRef.current = id;

    return () => clearInterval(intervalRef.current);
  }, []);

  const checkUserHaveNotificationBell = async () => {
    const resultCheckUserHaveNotificationBell =
      await sendRequestCheckUserHaveNotificationBell();
    setCountNotificationBell(resultCheckUserHaveNotificationBell);
  };

  const sendRequestCheckUserHaveNotificationBell = async () => {
    const headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/private-notification/check-private-notification",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return resultRequest.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  return (
    <div id="bell-dashboard-container">
      <Link to="/notification-private" className="hover position-relative pt-2">
        {countNotificationBell == 0 ? (
          <></>
        ) : (
          <span class="badge rounded-pill badge-notification bg-success position-absolute">
            {helpersNumbers.toPersianNum(countNotificationBell)}
          </span>
        )}

        <span>
          <i class="fas fa-bell"></i>
        </span>
      </Link>
    </div>
  );
}
